import {
  fetchPetrominCities,
  type PetrominCity,
} from "@/lib/petrominCitiesApi";
import {
  isLegacyGogoCityId,
  readSelectedCityFromCookies,
  writeSelectedNavCity,
  type SelectedNavCity,
} from "@/lib/navCityCookie";

export { isLegacyGogoCityId };

export function petrominCityToSelectedNavCity(
  city: PetrominCity
): SelectedNavCity {
  const nameEn = city.name.trim();
  const nameAr = city.native?.trim() || nameEn;
  const coords =
    city.latitude?.trim() && city.longitude?.trim()
      ? { latitude: city.latitude.trim(), longitude: city.longitude.trim() }
      : {};
  return {
    id: city.id,
    name: nameAr,
    nameEn,
    ...coords,
  };
}

export function pickDefaultRiyadhCity(
  cities: PetrominCity[]
): SelectedNavCity | null {
  const match = cities.find((c) => {
    const en = c.name.trim().toLowerCase();
    const ar = c.native?.trim();
    return en === "riyadh" || ar === "الرياض";
  });
  if (match) return petrominCityToSelectedNavCity(match);
  const first = cities[0];
  return first ? petrominCityToSelectedNavCity(first) : null;
}

let ensurePromise: Promise<SelectedNavCity | null> | null = null;

/**
 * Ensures `petromin_selected_city` exists with a Petromin CS UUID (not legacy GoGo id `1`).
 * Safe to call from layout and {@link NavCitySelector} — deduped per page load.
 */
export function ensureNavCityFromApi(): Promise<SelectedNavCity | null> {
  if (typeof window === "undefined") return Promise.resolve(null);

  const existing = readSelectedCityFromCookies();
  if (existing && !isLegacyGogoCityId(existing.id)) {
    return Promise.resolve(existing);
  }

  if (!ensurePromise) {
    ensurePromise = (async () => {
      try {
        const cities = await fetchPetrominCities();
        const city = pickDefaultRiyadhCity(cities);
        if (city) writeSelectedNavCity(city);
        return city;
      } catch {
        return null;
      }
    })();
  }

  return ensurePromise;
}
